/**
 * Differ homepage sections below the rail hero.
 * - The drop (home) and the products page: quick view popup with sizes. The bag icon adds to
 *   the real Shopify cart and turns the popup into "Added to bag" with the subtotal and
 *   Checkout; Buy now goes to checkout with just that tee.
 * - Sections fade up as they scroll in.
 * The header, menu and bag are the site's (differ-chrome.js).
 */
(function () {
  'use strict';
  if (window.DifferHome) return; // loaded by several sections
  window.DifferHome = true;

  var root = document.documentElement;
  root.classList.add('dx-js');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // The site bag and counts (differ-chrome.js, loaded by the Differ header on every page)
  function setCounts(n) {
    if (window.DifferChrome) window.DifferChrome.setCount(n);
  }

  // ---------------------------------------------------------------------------
  // Money, in the shop's format (prices shown without trailing .00, like the cards)
  // ---------------------------------------------------------------------------
  function formatMoney(cents, format) {
    format = format || '{{amount}}';
    var value = (cents || 0) / 100;
    function group(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] && !/^0+$/.test(parts[1]) ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return group(value, 2, ',', '.');
      }
    });
  }

  // ---------------------------------------------------------------------------
  // The drop: quick view popup -> "Added to bag" in the same popup
  // ---------------------------------------------------------------------------
  function initDrop(sec) {
    if (!sec || sec.dxReady) return;
    sec.dxReady = true;
    var qv = sec.querySelector('[data-dx-qv]');
    var scrim = sec.querySelector('[data-dx-qv-scrim]');
    if (!qv) return;
    // Out of the section so no ancestor's transform or overflow can trap the fixed popup
    document.body.appendChild(scrim);
    document.body.appendChild(qv);

    var moneyFormat = qv.getAttribute('data-money-format');
    var el = {
      card: qv.querySelector('[data-dx-qv-card]'),
      body: qv.querySelector('[data-dx-qv-body]'),
      media: qv.querySelector('[data-dx-qv-media]'),
      track: qv.querySelector('[data-dx-qv-track]'),
      prev: qv.querySelector('[data-dx-qv-prev]'),
      next: qv.querySelector('[data-dx-qv-next]'),
      thumbs: qv.querySelector('[data-dx-qv-thumbs]'),
      eyebrow: qv.querySelector('[data-dx-qv-eyebrow]'),
      title: qv.querySelector('[data-dx-qv-title]'),
      price: qv.querySelector('[data-dx-qv-price]'),
      offer: qv.querySelector('[data-dx-qv-offer]'),
      sizes: qv.querySelector('[data-dx-qv-sizes]'),
      add: qv.querySelector('[data-dx-qv-add]'),
      buy: qv.querySelector('[data-dx-qv-buy]'),
      error: qv.querySelector('[data-dx-qv-error]'),
      desc: qv.querySelector('[data-dx-qv-desc]'),
      link: qv.querySelector('[data-dx-qv-link]'),
      close: qv.querySelector('[data-dx-qv-close]'),
      paneProduct: qv.querySelector('[data-dx-qv-pane="product"]'),
      paneAdded: qv.querySelector('[data-dx-qv-pane="added"]'),
      addedImg: qv.querySelector('[data-dx-added-img]'),
      addedName: qv.querySelector('[data-dx-added-name]'),
      addedMeta: qv.querySelector('[data-dx-added-meta]'),
      addedPrice: qv.querySelector('[data-dx-added-price]'),
      addedCount: qv.querySelector('[data-dx-added-count]'),
      addedSubtotal: qv.querySelector('[data-dx-added-subtotal]'),
      addedSaving: qv.querySelector('[data-dx-added-saving]'),
      keep: qv.querySelector('[data-dx-keep-shopping]'),
      viewBag: qv.querySelector('[data-dx-view-bag]')
    };
    var cartUrl = qv.getAttribute('data-cart-url') || '/cart';
    var labels = {
      buy: el.buy.getAttribute('data-label-buy') || 'Buy now',
      pick: el.buy.getAttribute('data-label-pick') || 'Select a size',
      soon: el.buy.getAttribute('data-label-soon') || 'Coming soon',
      sold: el.buy.getAttribute('data-label-sold') || 'Sold out'
    };
    var item = null, variant = null, lastFocus = null, isOpen = false;

    function readItem(card) {
      var data = {};
      try { data = JSON.parse(card.querySelector('[data-dx-item]').textContent); } catch (e) { /* malformed: skip */ }
      return data;
    }

    // Buy now carries the state in words; the bag icon just follows it
    function setButton() {
      el.error.textContent = '';
      var label = labels.buy, off = false;
      if (!item.variants || !item.variants.length) { label = labels.soon; off = true; }
      else if (!item.variants.some(function (v) { return v.available; })) { label = labels.sold; off = true; }
      else if (!variant) label = labels.pick;
      el.buy.textContent = label;
      el.buy.disabled = off;
      el.add.disabled = off;
    }
    function needSize() {
      if (variant && variant.id) return false;
      // Bring the sizes into view (they can sit below the photo on phones)
      el.sizes.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      el.sizes.classList.remove('is-nudge');
      void el.sizes.offsetWidth;
      el.sizes.classList.add('is-nudge');
      return true;
    }

    // Gallery: hanger art first, then the product's photos
    var slideIndex = 0;
    function buildGallery() {
      var shots = item.gallery && item.gallery.length ? item.gallery : (item.image ? [{ src: item.image, thumb: item.image, alt: item.alt, hanger: item.hanger }] : []);
      el.track.innerHTML = '';
      el.thumbs.innerHTML = '';
      shots.forEach(function (g, i) {
        var slide = document.createElement('div');
        slide.className = 'dx-qv-slide' + (g.hanger ? '' : ' is-photo');
        var img = document.createElement('img');
        img.src = g.src;
        img.alt = g.alt || '';
        img.width = g.hanger ? 1212 : 1200;
        img.height = g.hanger ? 1320 : 1500;
        img.draggable = false;
        if (i > 0) img.loading = 'lazy';
        slide.appendChild(img);
        el.track.appendChild(slide);

        var t = document.createElement('button');
        t.type = 'button';
        t.className = g.hanger ? 'is-hanger' : '';
        t.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + shots.length);
        var ti = document.createElement('img');
        ti.src = g.thumb || g.src;
        ti.alt = '';
        ti.loading = 'lazy';
        t.appendChild(ti);
        t.addEventListener('click', function () { goTo(i); });
        el.thumbs.appendChild(t);
      });
      el.media.classList.toggle('is-single', shots.length < 2);
      el.track.scrollLeft = 0;
      setSlide(0);
    }
    function setSlide(i) {
      slideIndex = i;
      var n = el.track.children.length;
      [].forEach.call(el.thumbs.children, function (t, k) {
        t.classList.toggle('is-on', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      // Keep the active thumbnail in view (the strip scrolls when there are many photos)
      var on = el.thumbs.children[i], strip = el.thumbs;
      if (on) {
        if (on.offsetTop < strip.scrollTop) strip.scrollTop = on.offsetTop;
        else if (on.offsetTop + on.offsetHeight > strip.scrollTop + strip.clientHeight) strip.scrollTop = on.offsetTop + on.offsetHeight - strip.clientHeight;
        if (on.offsetLeft < strip.scrollLeft) strip.scrollLeft = on.offsetLeft;
        else if (on.offsetLeft + on.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = on.offsetLeft + on.offsetWidth - strip.clientWidth;
      }
      el.prev.disabled = i <= 0;
      el.next.disabled = i >= n - 1;
    }
    function goTo(i) {
      var slide = el.track.children[i];
      if (!slide) return;
      el.track.scrollTo({ left: slide.offsetLeft - el.track.offsetLeft - (parseFloat(getComputedStyle(el.track).scrollPaddingLeft) || 0), behavior: reduce ? 'auto' : 'smooth' });
      setSlide(i);
    }
    var scrollRaf = 0;
    el.track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        var w = el.track.children[0] ? el.track.children[0].offsetWidth : 0;
        if (w) setSlide(Math.min(el.track.children.length - 1, Math.round(el.track.scrollLeft / w)));
      });
    }, { passive: true });
    el.prev.addEventListener('click', function () { goTo(slideIndex - 1); });
    el.next.addEventListener('click', function () { goTo(slideIndex + 1); });

    // Mouse: drag the photo to the next or previous one (touch already swipes natively)
    var drag = null, dragDone = 0;
    el.track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0 || el.track.children.length < 2) return;
      e.preventDefault();
      clearTimeout(dragDone);
      drag = { x: e.clientX, left: el.track.scrollLeft, from: slideIndex };
      el.track.setPointerCapture(e.pointerId);
      el.track.classList.add('is-dragging');
    });
    el.track.addEventListener('pointermove', function (e) {
      if (drag) el.track.scrollLeft = drag.left - (e.clientX - drag.x);
    });
    function endDrag(e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      var to = drag.from;
      if (Math.abs(dx) > el.track.clientWidth * 0.12) to += dx < 0 ? 1 : -1;
      drag = null;
      goTo(Math.max(0, Math.min(el.track.children.length - 1, to)));
      // Snapping stays off until the glide lands, so it can't pull the photo back mid-way
      dragDone = setTimeout(function () { el.track.classList.remove('is-dragging'); }, reduce ? 0 : 450);
    }
    el.track.addEventListener('pointerup', endDrag);
    el.track.addEventListener('pointercancel', endDrag);

    // Show one pane; the hidden one is inert so Tab stays in the visible view
    function showPane(added) {
      qv.classList.toggle('is-added', added);
      el.paneProduct.inert = added;
      el.paneAdded.inert = !added;
    }

    function open(card) {
      item = readItem(card);
      variant = null;
      lastFocus = card;
      showPane(false);
      buildGallery();
      el.body.scrollTop = 0;
      el.eyebrow.textContent = item.eyebrow || '';
      el.title.textContent = item.name || item.title || '';
      el.price.innerHTML = item.priceHtml || '';
      el.offer.textContent = item.offer || '';
      el.offer.hidden = !item.offer;
      el.sizes.innerHTML = '';
      var vs = item.variants && item.variants.length ? item.variants : (item.sizes || []).map(function (s) { return { title: s, available: false, preview: true }; });
      vs.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = v.title;
        if (!v.available && !v.preview) { b.disabled = true; b.setAttribute('aria-label', v.title + ' (sold out)'); }
        b.addEventListener('click', function () {
          if (!v.id) return;
          variant = v;
          [].forEach.call(el.sizes.children, function (c) { c.classList.toggle('is-on', c === b); c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
          setButton();
        });
        el.sizes.appendChild(b);
      });
      // Start on M (the usual pick), or the first size in stock if M is sold out
      var avail = (item.variants || []).filter(function (v) { return v.available && v.id; });
      var pick = avail.filter(function (v) { return /^m$/i.test(v.title); })[0] || avail[0];
      if (pick) el.sizes.children[item.variants.indexOf(pick)].click();
      setButton();
      // The description as written on the Shopify product
      el.desc.innerHTML = item.description || '';
      el.desc.hidden = !item.description;
      if (item.url) { el.link.href = item.url; el.link.hidden = false; } else { el.link.hidden = true; }

      qv.classList.add('is-open');
      scrim.classList.add('is-open');
      qv.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      isOpen = true;
      el.card.focus({ preventScroll: true });
    }

    function close(restoreFocus) {
      if (!isOpen) return;
      qv.classList.remove('is-open');
      scrim.classList.remove('is-open');
      qv.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      isOpen = false;
      if (restoreFocus !== false && lastFocus) lastFocus.focus({ preventScroll: true });
    }

    function showAdded(line, cart) {
      el.addedImg.src = item.image || '';
      el.addedImg.parentNode.classList.toggle('is-photo', !item.hanger);
      el.addedName.textContent = item.title || line.product_title || '';
      el.addedMeta.textContent = variant && variant.title && variant.title !== 'Default Title' ? 'Size ' + variant.title : '';
      el.addedPrice.textContent = formatMoney(line.price, moneyFormat);
      var n = cart.item_count || 0;
      el.addedCount.textContent = '(' + n + (n === 1 ? ' item)' : ' items)');
      el.addedSubtotal.textContent = formatMoney(cart.total_price, moneyFormat);
      // Automatic offers (e.g. 2 for ...) show as a saving under the subtotal
      var offer = [];
      (cart.items || []).forEach(function (it) {
        (it.discounts || []).forEach(function (d) { if (d.title && offer.indexOf(d.title) < 0) offer.push(d.title); });
      });
      el.addedSaving.hidden = !(cart.total_discount > 0);
      el.addedSaving.textContent = (offer.length ? offer.join(', ') + ' · ' : '') + 'You save ' + formatMoney(cart.total_discount, moneyFormat);
      showPane(true);
      el.body.scrollTop = 0;
      el.card.focus({ preventScroll: true });
    }

    sec.querySelectorAll('[data-dx-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        open(card);
      });
    });
    el.close.addEventListener('click', close);
    scrim.addEventListener('click', close);
    window.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') close();
      else if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !qv.classList.contains('is-added')) {
        e.preventDefault();
        goTo(slideIndex + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    el.keep.addEventListener('click', close);

    // View bag: the site bag drawer (the link to the cart page is the fallback)
    el.viewBag.addEventListener('click', function (e) {
      if (!window.DifferChrome) return;
      e.preventDefault();
      close(false);
      window.DifferChrome.openBag();
    });

    el.add.addEventListener('click', function () {
      if (el.add.disabled || el.add.classList.contains('is-busy') || needSize()) return;
      el.add.classList.add('is-busy');
      el.error.textContent = '';
      var line = null;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
            return data;
          });
        })
        .then(function (data) {
          line = (data.items && data.items[0]) || data;
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          el.add.classList.remove('is-busy');
          setCounts(cart.item_count || 0);
          showAdded(line, cart);
        })
        .catch(function (err) {
          el.add.classList.remove('is-busy');
          el.error.textContent = err.message;
        });
    });

    // Buy now: straight to checkout with just this tee (a cart link: /cart/<variant>:<qty>)
    el.buy.addEventListener('click', function () {
      if (el.buy.disabled || el.buy.classList.contains('is-busy') || needSize()) return;
      el.buy.classList.add('is-busy');
      window.location.href = cartUrl.replace(/\/$/, '') + '/' + variant.id + ':1';
    });
    // Coming back from checkout with the browser's Back button: don't leave it spinning
    window.addEventListener('pageshow', function () { el.buy.classList.remove('is-busy'); });
  }

  // ---------------------------------------------------------------------------
  // Reveal
  // ---------------------------------------------------------------------------
  var io = 'IntersectionObserver' in window && !reduce
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  function initReveal(scope) {
    (scope || document).querySelectorAll('.dx-reveal:not(.is-in)').forEach(function (n) {
      if (io) io.observe(n);
      else n.classList.add('is-in');
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-dx-drop]').forEach(initDrop);
    initReveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor: re-run for a re-rendered section (its old quick view moved to <body> goes stale)
  document.addEventListener('shopify:section:load', function (e) {
    document.querySelectorAll('body > [data-dx-qv], body > [data-dx-qv-scrim]').forEach(function (n) {
      if (n.getAttribute('data-section') === e.detail.sectionId) n.remove();
    });
    initAll(e.target);
  });
})();
